import React from 'react';
import { UserPlusIcon } from '@heroicons/react/24/outline';
import { NewPlayerPayload } from '../../../generated-api';
import { CompactEventRow } from './CompactEventRow';

interface NewPlayerCardProps {
  payload: NewPlayerPayload;
  createdAt: string;
}

export const NewPlayerCard: React.FC<NewPlayerCardProps> = ({ payload, createdAt }) => (
  <CompactEventRow
    track="feed_new_player_card"
    to={`/players/${payload.playerId}`}
    icon={<UserPlusIcon className="h-4 w-4" />}
    iconClassName="bg-green-100 text-green-600"
    label="New Player Joined"
    createdAt={createdAt}
    thumbnail={payload.playerAvatar}
  >
    <span className="font-medium text-heading">{payload.playerName}</span>
    {' joined'}
  </CompactEventRow>
);
